import { Wrapper, OrderSummaryStyle } from "./cart.style";
import { Container, Row, Col, Button } from "reactstrap";
import { memo, useEffect } from "react";
import { AuthCustomModalDescriptionStyleB } from "../../../../../../layouts/auth/auth.layout.style";
import { AddressManagementModalComponent } from "../../../../../../components/addressManagement";
import { ComponentLoader } from "../../../../../../components/loaders";
import { BsCart2 } from "react-icons/bs";
import { CgClose } from "react-icons/cg";
import { CartItem } from "./components/cartItem";
import CartCheckbox from "./components/cartCheckbox";
import { useUserCart } from "../../../../../../hooks/userCart.hook";
import { Mixpanel } from "../../../../../../utils/mixpanel";

export const CartSection = memo(() => {
  const {
    normalizedItems,
    cartItems,
    // actions
    isAllSelected,
    loading,
    actionLoading,

    //functions
    toggleSelectAll,
    toggleSelect,
    navigate,
    updateQuantity,
    updateCartItemQuantity,
    handleRemove,
    handleCartItemClick,
    subTotal,
    total,
    selectedItems,
    onCheckout,
    isAddressModalOpen,
    toggleAddressModal,
  } = useUserCart();
  
  useEffect(() => {
    Mixpanel.track_view_cart_screen(cartItems?.length || 0);
  }, []);
  return (
    <Wrapper>
      <Container>
        <Row xl={12}>
          <Col md={7}>
            <div className="first_content d-flex align-items-center justify-content-between my-3 header">
              <span className={"inherit-all m-0"}>
                Shopping Cart ({cartItems.length}{" "}
                {cartItems.length === 1 ? "item" : "items"})
              </span>
              <div
                className="close-btn tw-cursor-pointer"
                onClick={() => navigate(-1)}
              >
                <CgClose size={25} />
              </div>
            </div>

            {normalizedItems.length > 0 && (
              <div className="select-all-header d-flex align-items-center">
                <CartCheckbox
                  checked={isAllSelected}
                  onChange={toggleSelectAll}
                />
                <span className="tw-ml-2 tw-font-medium">
                  {isAllSelected ? "Deselect All" : "Select All"}
                </span>
              </div>
            )}

            <div className="cart-icons-line md-hidden"></div>
            {loading ? (
              <ComponentLoader />
            ) : normalizedItems.length === 0 ? (
              <div className="text-center d-flex flex-column justify-content-center align-items-center tw-space-y-4 py-5">
                <BsCart2 size={54} color={"#0B9C07"} />
                <h3 className="text-muted tw-font-semibold !tw-text-[#2B2B2B] text-lg">
                  Your cart is empty
                </h3>
                <p className="text-muted">
                  When you add item to your cart, it will appear here.
                </p>
                <Button
                  outline
                  className={"custom-btn-outline-secondary"}
                  href="/split-buy"
                >
                  Continue Shopping
                </Button>
              </div>
            ) : (
              normalizedItems.map((item) => (
                <CartItem
                  key={item._id || item.cart_item_id}
                  item={item}
                  onToggle={toggleSelect}
                  onQuantityChange={updateQuantity}
                  onRemove={handleRemove}
                  onClick={() => handleCartItemClick(item)}
                />
              ))
            )}
          </Col>
          <Col className={"order-summary-col"} md={5}>
            <OrderSummaryStyle>
              <div className="first_content my-md-3 header">Order Summary</div>
              <div className="cart-icons-line md-hidden"></div>
              <div className="first_content sub-total d-flex justify-content-between mb-md-3 header">
                <h4 className="title">Sub-Total:</h4>
                <h6>
                  <h6>₦{subTotal?.toLocaleString()}</h6>
                </h6>
              </div>
              <div className="cart-icons-line"></div>
              <div className="first_content total d-flex justify-content-between mb-md-3 header">
                <h4 className="title">Total:</h4>
                <h6>
                  <h6>₦{total?.toLocaleString()}</h6>
                </h6>
              </div>
              <div className="selected-items-info mb-3">
                <small className="text-muted">
                  {selectedItems.length}{" "}
                  {selectedItems.length === 1 ? "item" : "items"} selected
                  {isAllSelected && " (All items)"}
                </small>
              </div>

              <div className="cart-icons-line"></div>
              <AuthCustomModalDescriptionStyleB className={"my-4"}>
                By proceeding, you agree to our{" "}
                <a href="/terms-and-conditions">Terms of Use</a> and{" "}
                <a href="/privacy-policy">Privacy Policy</a>
              </AuthCustomModalDescriptionStyleB>
              <Button
                onClick={onCheckout}
                disabled={selectedItems.length === 0 || actionLoading}
                className={"mb-3 custom-app-btn"}
              >
                Checkout Now (₦{total?.toLocaleString()})
              </Button>
              <Button onClick={() => navigate("/split-buy")} outline={true}>
                Continue Shopping
              </Button>
            </OrderSummaryStyle>
          </Col>
        </Row>
      </Container>
      <div className="mobile-sticky-checkout">
        <Button
          onClick={onCheckout}
          disabled={selectedItems.length === 0}
          className={"sticky-checkout-btn"}
        >
          Checkout Now (₦{total?.toLocaleString()})
        </Button>
      </div>

      {/*<AddressManagementModalComponent*/}
      {/*  onAddressAdded={onCheckout}*/}
      {/*  view={"add"}*/}
      {/*  isOpen={isAddressModalOpen}*/}
      {/*  toggle={toggleAddressModal}*/}
      {/*/>*/}
    </Wrapper>
  );
});
